import formatPageLinks from "../formatPageLinks"
import { Link } from "gatsby"
import RichTextConnector from "../../../components/RichText/RichTextConnector"
import React from "react"

export const formatLayoutButtons = ({
  buttons,
  locale,
  siteIdentifier,
  homepageSlug,
  currentSpaceId,
  Link,
}) => {
  return buttons?.map(button => {
    const formattedButton = formatPageLinks(
      button,
      locale,
      button?.url?.__typename,
      homepageSlug,
      currentSpaceId,
      siteIdentifier
    )

    return {
      ...button,
      label: formattedButton?.text || formattedButton?.label,
      destination: formattedButton?.url || formattedButton?.linkUrl,
      primary: button?.isPrimary,
      Link: Link,
      downloadName: formattedButton?.downloadName,
    }
  })
}

export const formatRichTextTheme = formattedTheme => {
  return formattedTheme === "t2-preset-theme-one" ||
    formattedTheme === "t2-preset-theme-two" ||
    formattedTheme === "t2-preset-theme-six"
    ? "transparent-dark-text"
    : "transparent-light-text"
}

export const formatThemePreset = theme => {
  switch (theme) {
    case "White":
      return "t2-preset-theme-one"
    case "Grey":
    case "Gray":
      return "t2-preset-theme-two"
    case "Black":
      return "t2-preset-theme-three"
    case "Blue":
      return "t2-preset-theme-four"
    case "Dark Blue":
      return "t2-preset-theme-five"
    case "Textured Light":
      return "t2-preset-theme-six" // transparent bg
    case "Textured Dark":
      return "t2-preset-theme-seven"
    default:
      return "t2-preset-theme-one"
  }
}

export const formatCommonComponentFields = (
  data,
  locale,
  siteIdentifier,
  homepageSlug,
  currentSpaceId
) => {
  const formattedButtons = formatLayoutButtons({
    buttons: data?.buttons,
    locale: locale,
    siteIdentifier: siteIdentifier,
    homepageSlug: homepageSlug,
    currentSpaceId: currentSpaceId,
    Link: Link,
  })
  const formattedTheme = formatThemePreset(data?.theme)
  const richTextTheme = formatRichTextTheme(formattedTheme)

  let descriptionElement = null
  if (data?.layoutDescription) {
    descriptionElement = (
      <RichTextConnector
        data={{ content: data?.layoutDescription }}
        overrideTheme={richTextTheme}
        contentType={data?.__typename}
      />
    )
  }

  return {
    ...data,
    description: descriptionElement,
    subheader: data?.subheader?.subheader,
    buttons: formattedButtons,
    presetTheme: formattedTheme,
    isHeaderBig: data?.isHeaderBig || false,
  }
}
